import { extend } from 'flarum/extend';
import app from 'flarum/forum/app';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import Stream from 'flarum/common/utils/Stream';
import Button from 'flarum/common/components/Button';

import UploadComponent from './components/UploadComponent';
import CaptchaComponent from './components/CaptchaComponent';
import showAlert from './common/util/showAlert';
import setInputError from "./common/util/setInputError";
import SiteInfoYouKePlanModal from "./components/modal/SiteInfoYouKePlanModal";

export default function addSignUpField() {

  extend(SignUpModal.prototype, 'onready', function () {
    let passwordInput = $(".PasswordField").find(".FormControl");

    $(".StrengthIndicator").hide();
    passwordInput.on('input',function(e){
      const passwordValue = e.target.value;
      
      if(passwordValue===""){
        $(".StrengthIndicator").hide();
      }else{
        $(".StrengthIndicator").show()
      }
    })
  });

  extend(SignUpModal.prototype, 'oncreate', function () {
    const _this = this;

    $(".Modal-body").find(".Form-group").slice(5).hide();
    $(".Button--primary[type=submit]").hide();

    $("#u2di_lxdh_wx_checked").change(function() {
      _this.item.u2di_lxdh_wx_checked(this.checked);

      if(this.checked){
        _this.item.u2di_lxdh_wx(_this.item.u2di_lxdh());
      }else{
        _this.item.u2di_lxdh_wx("");
      }

      m.redraw();
    }); 

    $('input[type=radio][name=option_userTitle]').on('change', function() {
      let value = parseInt($(this).val());
      _this.item.u2di_zsxm_title(value);
      m.redraw();
    });
  });

  extend(SignUpModal.prototype, 'oninit', function () {
    this.u2diCaptcha = Stream("");
    this.item = {};
    this.item.u2di_inviteCodeValidated = false;
    this.item.u2di_inviteCode = Stream("");
    this.item.u2di_inviteCode = Stream("");
    this.item.u2di_userType = Stream("0");
    this.item.u2di_bmqy = Stream("");
    this.item.u2di_zjgw = Stream("");
    this.item.u2di_zsxm = Stream("");
    this.item.u2di_zsxm_title = Stream(0);
    this.item.u2di_lxdh = Stream("");
    this.item.u2di_lxdh_wx = Stream("");
    this.item.u2di_lxdh_wx_checked = Stream(false);
    this.item.u2di_lxdh_wx_qr = Stream([]);
    this.item.u2di_khh = Stream("");
    this.item.u2di_yhkh = Stream("");
    this.item.u2di_sfzh = Stream("");
    this.startDate = Stream("");
    this.validDuration = Stream("");
  });

  SignUpModal.prototype.validateInviteCode = function(){
    const inviteCode = (this.item.u2di_inviteCode()).trim();

    if(inviteCode){
      this.loading = true;

      app.store
        .find("u2diInviteCode",{inviteCode:inviteCode,u2diCaptcha:this.u2diCaptcha()})
        .catch(() => {
          this.loading = false;
          $(".u2diCaptcheImage").click();
          m.redraw();
        })
        .then((result) => {
          this.loading = false;
          const validateData = result[0];

          if(validateData){
            const realName = validateData.realName();
            const validDuration = validateData.validDuration();
            const currentDate = validateData.currentDate();
            const validDurationText = "duration-"+validDuration;
            
            $(".Modal-body").find(".Form-group").show();
            this.validDuration(app.translator.trans('ziven-u2di.lib.'+validDurationText));
            this.startDate(currentDate);
            this.item.u2di_zsxm(realName);
            this.item.u2di_inviteCodeValidated = true;
          }else{
            this.item.u2di_inviteCodeValidated = false;
            showAlert(app.translator.trans("ziven-u2di.forum.error-invalid-invite-code"));
          }

          m.redraw();
      });
    };
  }

  extend(SignUpModal.prototype, 'fields', function (items) {
    const _this = this;

    items.add(
      'u2di-zcmyz',
      <div className="Form-group u2diFormGroup">
        <div className="Form-group">
          <div style="font-size:16px;" className="u2diSignUpCategoryTitle">
            {app.translator.trans('ziven-u2di.forum.signup-category-zcmyz')}通过 <span style="cursor:pointer;color:rgb(0, 161, 214)" onclick={()=>{app.modal.show(SiteInfoYouKePlanModal,{wrapData:{returnModal:"SignUpModal"}})}}>优客计划</span> 获取
          </div>
        </div>
        <div className="Form-group">
          <input disabled={this.loading || this.item.u2di_inviteCodeValidated} required className="FormControl" type="text" bidi={this.item.u2di_inviteCode} placeholder={app.translator.trans('ziven-u2di.forum.signup-field-invite-code')} />
        </div>
        
        {this.item.u2di_inviteCodeValidated===false && (
          <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
            <div style="display: flex;" className="u2diUserSubmitCategoryItemOptions">
              <input id="u2diCaptcha" disabled={this.loading} required className="FormControl u2diUserSubmitCategoryItemInput" type="input" maxlength="4" bidi={this.u2diCaptcha} placeholder="人机验证" />
              <CaptchaComponent />
            </div>
          </div>
        )}

        <div style="display:none" className="Form-group">
          <input disabled required className="FormControl" type="text" bidi={this.item.u2di_zsxm} />
        </div>
        <div style={this.item.u2di_inviteCodeValidated?"display:none":""} className="Form-group">
          <Button loading={this.loading} style="margin-top: 10px;" className="Button Button--primary" onclick={() => this.validateInviteCode() }>
            {app.translator.trans('ziven-u2di.forum.button-code-validate')}
          </Button>
        </div>
        <div style={this.item.u2di_inviteCodeValidated?"":"display:none;"} className="Form-group">
          {app.translator.trans('ziven-u2di.forum.signup-validate-success',{date:this.startDate(),duration:this.validDuration()})}
        </div>
      </div>,
      51
    );

    items.add(
      'u2di-zhzcxx',
      <div className="Form-group">
        <div className="u2diSignUpCategoryTitle">
          {app.translator.trans('ziven-u2di.forum.signup-category-zhzcxx')}
        </div>
      </div>,
      50
    );

    items.add(
      'u2di-yhxx',
      <div className="Form-group">
        <div className="u2diSignUpCategoryTitle Form-group">
          {app.translator.trans('ziven-u2di.forum.signup-category-yhxx')}
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-bmqy')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input disabled={this.loading} type="text" className="FormControl" bidi={this.item.u2di_bmqy}  placeholder={app.translator.trans('ziven-u2di.lib.optional')} />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-zjgw')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input disabled={this.loading} type="text" className="FormControl" bidi={this.item.u2di_zjgw}  placeholder={app.translator.trans('ziven-u2di.lib.optional')} />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-zsxm')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input id="u2di_zsxm" required disabled type="text" className="FormControl" bidi={this.item.u2di_zsxm} />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <div style="display: flex;height: 40px;align-items: center;">
              <div style="display: flex;align-items: center;"><input disabled={this.loading} id="userTitle1" type="radio" name="option_userTitle" value="0" checked={this.item.u2di_zsxm_title()==0?"checked":""} /><label style="margin-left: 5px;" for="userTitle1">{app.translator.trans('ziven-u2di.forum.signup-field-user-zsxm-title-0')}</label></div>
              <div style="display: flex;align-items: center;margin-left:10px"><input disabled={this.loading} id="userTitle2" type="radio" name="option_userTitle" value="1" checked={this.item.u2di_zsxm_title()==1?"checked":""} /><label style="margin-left: 5px;" for="userTitle2">{app.translator.trans('ziven-u2di.forum.signup-field-user-zsxm-title-1')}</label></div>
            </div>
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-lxdh')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input id="u2di_lxdh" disabled={this.loading} required type="text" maxlength="11" className="FormControl" bidi={this.item.u2di_lxdh}  placeholder={app.translator.trans('ziven-u2di.lib.required')} />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <div style="display: flex;height: 40px;align-items: center;">
              <input style="margin-left: 0px;" id="u2di_lxdh_wx_checked" className="u2diUserSubmitCategoryItemRadio" type="checkbox" value="0" /><label style="margin-left: 5px;" for="u2di_lxdh_wx_checked">{app.translator.trans('ziven-u2di.forum.signup-field-lxdh-wx-checked')}</label>
            </div>
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-lxdh-wx')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input id="u2di_lxdh_wx" disabled={this.loading || this.item.u2di_lxdh_wx_checked()} required type="text" maxlength="11" className="FormControl" bidi={this.item.u2di_lxdh_wx_checked()?this.item.u2di_lxdh:this.item.u2di_lxdh_wx}  placeholder={app.translator.trans('ziven-u2di.lib.required')} />
          </div>
        </div>

      </div>,
      0
    );

    items.add(
      'u2di-ykxx',
      <div className="Form-group">
        <div className="u2diSignUpCategoryTitle Form-group">
          {app.translator.trans('ziven-u2di.forum.signup-category-ykxx')}
        </div>
        
        <div className="u2diUserSubmitCategoryItems" style="text-align: left;align-items: baseline;">
          <div style="margin-top: -10px;" className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-lxdh-wx-qr')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <UploadComponent uploadLimit="1" uploadType="u2di_lxdh_wx_qr" uploadTarget={this.item.u2di_lxdh_wx_qr} uploadCallback={function(result,option_target){
              // _this.item.u2di_lxdh_wx_qr = option_target;
            }} />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-khh')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input tid="u2di_khh" disabled={this.loading} type="text" className="FormControl" bidi={this.item.u2di_khh}  placeholder={app.translator.trans('ziven-u2di.lib.optional')} />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-yhkk')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input tid="u2di_yhkh" disabled={this.loading} type="text" className="FormControl" bidi={this.item.u2di_yhkh} placeholder={app.translator.trans('ziven-u2di.lib.optional')} />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
          <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
            {app.translator.trans('ziven-u2di.forum.signup-field-sfzh')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
            <input tid="u2di_sfzh" disabled={this.loading} type="text" className="FormControl" bidi={this.item.u2di_sfzh}  placeholder={app.translator.trans('ziven-u2di.lib.optional')} />
          </div>
        </div>

        <div className="Form-group">
          <Button loading={this.loading} style="margin-top: 10px;width:100%" className="Button Button--primary" onclick={() => this.checkRegisterData() }>
              注册
          </Button>
        </div>
      </div>,
      0
    );
  });

  SignUpModal.prototype.checkRegisterData = function(){
    const wrapData = this.item;
    let isValid = true;

    for(let index in wrapData){
      if(typeof(wrapData[index])!=="function"){
        continue;
      }

      if((wrapData[index]()).length===0 && $("#"+index).length>0 && $("#"+index).prop('disabled')!==true){
        setInputError("#"+index,isValid);
        isValid = false;
      }
    }

    if(isValid===true){
      $(".Button--primary[type=submit]").click();
    }
  }

  extend(SignUpModal.prototype, 'submitData', function (data) {
      data.u2di_userType = this.item.u2di_userType();
      data.u2di_bmqy = this.item.u2di_bmqy();
      data.u2di_zjgw = this.item.u2di_zjgw();
      data.u2di_zsxm = this.item.u2di_zsxm();
      data.u2di_zsxm_title = this.item.u2di_zsxm_title();
      data.u2di_lxdh = this.item.u2di_lxdh();
      data.u2di_lxdh_wx = this.item.u2di_lxdh_wx_checked()?this.item.u2di_lxdh():this.item.u2di_lxdh_wx();
      data.u2di_lxdh_wx_qr = this.item.u2di_lxdh_wx_qr();
      data.u2di_khh = this.item.u2di_khh();
      data.u2di_yhkh = this.item.u2di_yhkh();
      data.u2di_sfzh = this.item.u2di_sfzh();
      data.u2di_inviteCode = this.item.u2di_inviteCode();
  });
}
